/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-07-22 00:00:00
 *
 *******************************************************/
//flow

import type { Action } from './store.type';

export const EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST =
  'EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST';
type EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST_TYPE = 'EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST';

export const EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS =
  'EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS';
type EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS_TYPE = 'EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS';

export const EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE =
  'EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE';
type EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE_TYPE = 'EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE';

export const GET_EXP_REVIEW_RATING_STATUS_REQUEST = 'GET_EXP_REVIEW_RATING_STATUS_REQUEST';
type GET_EXP_REVIEW_RATING_STATUS_REQUEST_TYPE = 'GET_EXP_REVIEW_RATING_STATUS_REQUEST';

export const GET_EXP_REVIEW_RATING_STATUS_SUCCESS = 'GET_EXP_REVIEW_RATING_STATUS_SUCCESS';
type GET_EXP_REVIEW_RATING_STATUS_SUCCESS_TYPE = 'GET_EXP_REVIEW_RATING_STATUS_SUCCESS';

export const GET_EXP_REVIEW_RATING_STATUS_FAILURE = 'GET_EXP_REVIEW_RATING_STATUS_FAILURE';
type GET_EXP_REVIEW_RATING_STATUS_FAILURE_TYPE = 'GET_EXP_REVIEW_RATING_STATUS_FAILURE';

export const RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK = 'RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK';
type RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK_TYPE = 'RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK';

type ExpReviewRatingSuccess = {
  data: {
    status: string,
    code: number
  }
};

type GetExpReviewRatingStatusSuccess = {
  data: {
    allowToShowReview: boolean,
    step: string,
    rating: number
  }
};

type ExpReviewRatingFailure = {
  error: any
};

type ExpReviewRatingRequestAction = Action<EXP_REVIEW_RATING_SUBMIT_FEEDBACK_REQUEST_TYPE, null>;

type ExpReviewRatingSuccessAction = Action<
  EXP_REVIEW_RATING_SUBMIT_FEEDBACK_SUCCESS_TYPE,
  ExpReviewRatingSuccess
>;

type ExpReviewRatingFailureAction = Action<
  EXP_REVIEW_RATING_SUBMIT_FEEDBACK_FAILURE_TYPE,
  ExpReviewRatingFailure
>;

type GetExpReviewRatingStatusRequestAction = Action<
  GET_EXP_REVIEW_RATING_STATUS_REQUEST_TYPE,
  null
>;

type GetExpReviewRatingStatusSuccessAction = Action<
  GET_EXP_REVIEW_RATING_STATUS_SUCCESS_TYPE,
  GetExpReviewRatingStatusSuccess
>;

type GetExpReviewRatingStatusFailureAction = Action<
  GET_EXP_REVIEW_RATING_STATUS_FAILURE_TYPE,
  ExpReviewRatingFailure
>;

type ResetExpReviewRatingAction = Action<RESET_EXP_REVIEW_RATING_SUBMIT_FEEDBACK_TYPE, null>;

export type ExpReviewRatingAction =
  | ExpReviewRatingRequestAction
  | ExpReviewRatingSuccessAction
  | ExpReviewRatingFailureAction
  | GetExpReviewRatingStatusRequestAction
  | GetExpReviewRatingStatusSuccessAction
  | GetExpReviewRatingStatusFailureAction
  | ResetExpReviewRatingAction;

export type ExpReviewRatingState = {
  expReviewRatingLoading: boolean,
  expReviewRatingSuccess: boolean,
  expReviewRatingStatusLoading: boolean,
  expReviewRatingStatusSuccess: boolean,
  allowToShowReview: boolean,
  allowToShowButton: boolean,
  step: string,
  rating: number,
  clicks: number,
  status: boolean,
  event: string,
  triggeredAt: number,
  error: any
};
